export const base: string = '319px';
export const xBase: string = '374px';
export const hBase: string = '414px';
export const sTab: string = '768px';
export const tab: string = '901px';
export const hTab: string = '1024px';
export const lTab: string = '1240px';
export const laptop: string = '1440px';
export const descktop: string = '1600px';
export const fullHD: string = '1920px';
export const hFullHD: string = '1080px';
export const smallHeight: string = '768px';